<template>
  <TermsOfUseBY v-if="locale.currentCountry === COUNTRY_CODE.BY" />
  <TermsOfUseKZ v-else-if="locale.currentCountry === COUNTRY_CODE.KZ" />
  <TermsOfUseKG v-else-if="locale.currentCountry === COUNTRY_CODE.KG" />
  <TermsOfUseCIS v-else-if="locale.currentCountry !== COUNTRY_CODE.RU" />
  <TermsOfUseRU v-else />
</template>

<script setup lang="ts">
import { COUNTRY_CODE } from '~/core/i18n'
import { generatePageMetaLinks } from '~/core/seo'
import TermsOfUseRU from '~/features/terms-of-use/TermsOfUseRU.vue'
import TermsOfUseBY from '~/features/terms-of-use/TermsOfUseBY.vue'
import TermsOfUseKZ from '~/features/terms-of-use/TermsOfUseKZ.vue'
import TermsOfUseKG from '~/features/terms-of-use/TermsOfUseKG.vue'
import TermsOfUseCIS from '~/features/terms-of-use/TermsOfUseCIS.vue'

definePageMeta({
  layout: 'sidebar',
})

const locale = useAppLocale()

useHead({
  link: generatePageMetaLinks(),
})
</script>
